import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full py-6 mt-20 border-t border-white/10 bg-black/40 backdrop-blur-md text-center z-40 relative">
      <div className="container mx-auto px-6">
        <p className="text-sm text-gray-400 font-bold">
          تم تصميم الموقع من قبل تيم زاهيه ديف
        </p>
        <p className="text-lg font-black text-neon-cyan mt-2 tracking-wider">
          سعد الاولين
        </p>
      </div>
    </footer>
  );
}